var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutside),expression:"clickOutside"}],ref:"menu",staticClass:"tw-absolute tw-bg-white tw-p-2 tw-rounded tw-flex tw-flex-col tw-text-gray-text tw-z-20",class:_vm.align,attrs:{"id":"modal-dropdown-menu"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }